import ImageOne from '../images/ImageTen.png'

export const MidData = {
    heading: 'Segurança',
    paragraphOne: 'Desde o primeiro instante até a entrega final da sua obra seu projeto será acompanhado de perto, para que o resultado seja aquilo que sempre sonhou.',
    paragraphTwo: '',
    buttonLabel: 'Ver mais',
    image: ImageOne,
    reverse: false,
    delay: 100,
};